import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";

export const FontParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: null,
  bg: "rgba(100, 100, 200, 0.25)",
  animate: async (particle: Particle<void>) => {
    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(100, 100, 200, 0.75)",
      to: "rgba(100, 100, 200, 0.25)",
      duration: 200,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });

    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(255, 100, 200, 0.25)",
      to: "rgba(255, 255, 255, 0.75)",
      duration: 200,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });
    await awaitAnimate({
      driver: particle.driver,
      from: "rgba(255, 255, 255, 0.75)",
      to: "rgba(255, 100, 200, 0.25)",
      duration: 200,
      onUpdate: (latest) => {
        particle.bg = latest;
      },
    });
  },
};
